import axios from 'axios';

const PUBLIC = '/dotnet_api/v1/portal/public';
const AUTH_JSON = (token) => ({
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

export const fetchPortalHome = () => axios.get(`${PUBLIC}/home`).then((r) => r.data);

export const fetchPortalPosts = (params = {}) =>
  axios.get(`${PUBLIC}/posts`, { params }).then((r) => r.data);

export const fetchPortalPost = (slug) =>
  axios.get(`${PUBLIC}/posts/${encodeURIComponent(slug)}`).then((r) => r.data);

export const unlockPortalPost = (slug, password) =>
  axios.post(`${PUBLIC}/posts/${encodeURIComponent(slug)}/unlock`, { password }).then((r) => r.data);

export const fetchPortalMetric = (key) =>
  axios.get(`${PUBLIC}/metrics/${encodeURIComponent(key)}`).then((r) => r.data);

const tokenFromState = (getState) => getState?.()?.userLogin?.userInfo?.token
  || (localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).token : null);

export const listPortalPostsAdmin = (params = {}) => {
  const token = tokenFromState();
  return axios.get('/dotnet_api/v1/portalPost/all', { ...AUTH_JSON(token), params }).then((r) => r.data);
};

export const getPortalPostAdmin = (id) => {
  const token = tokenFromState();
  return axios.get(`/dotnet_api/v1/portalPost/${id}`, AUTH_JSON(token)).then((r) => r.data);
};

export const createPortalPost = (body) => {
  const token = tokenFromState();
  return axios.post('/dotnet_api/v1/portalPost', body, AUTH_JSON(token)).then((r) => r.data);
};

export const updatePortalPost = (id, body) => {
  const token = tokenFromState();
  return axios.put(`/dotnet_api/v1/portalPost/${id}`, body, AUTH_JSON(token)).then((r) => r.data);
};

export const deletePortalPost = (id) => {
  const token = tokenFromState();
  return axios.delete(`/dotnet_api/v1/portalPost/${id}`, AUTH_JSON(token));
};

export const listPortalCategories = (params = { limit: 100 }) => {
  const token = tokenFromState();
  return axios.get('/dotnet_api/v1/portalCategory/all', { ...AUTH_JSON(token), params }).then((r) => r.data);
};

export const createPortalCategory = (body) => {
  const token = tokenFromState();
  return axios.post('/dotnet_api/v1/portalCategory', body, AUTH_JSON(token)).then((r) => r.data);
};

export const updatePortalCategory = (id, body) => {
  const token = tokenFromState();
  return axios.put(`/dotnet_api/v1/portalCategory/${id}`, body, AUTH_JSON(token)).then((r) => r.data);
};

export const deletePortalCategory = (id) => {
  const token = tokenFromState();
  return axios.delete(`/dotnet_api/v1/portalCategory/${id}`, AUTH_JSON(token));
};

export const listPortalTags = (params = { limit: 100 }) => {
  const token = tokenFromState();
  return axios.get('/dotnet_api/v1/portalTag/all', { ...AUTH_JSON(token), params }).then((r) => r.data);
};

export const createPortalTag = (body) => {
  const token = tokenFromState();
  return axios.post('/dotnet_api/v1/portalTag', body, AUTH_JSON(token)).then((r) => r.data);
};

export const updatePortalTag = (id, body) => {
  const token = tokenFromState();
  return axios.put(`/dotnet_api/v1/portalTag/${id}`, body, AUTH_JSON(token)).then((r) => r.data);
};

export const getPortalSite = () => {
  const token = tokenFromState();
  return axios.get('/dotnet_api/v1/portalSite', AUTH_JSON(token)).then((r) => r.data);
};

export const updatePortalSite = (body) => {
  const token = tokenFromState();
  return axios.put('/dotnet_api/v1/portalSite', body, AUTH_JSON(token)).then((r) => r.data);
};
